'use strict';

angular.module('webAgro1App').directive('dynamicInclude', function() {
  return {
    scope: {
      object: '=',
      template: '='
    },
    replace: true,
    restrict: 'E',
    template: '<ng-include src="template"> </ng-include>',
  };
});